export default "__VITE_ASSET__Dbo_zISi__"